import { ColumnConfig } from "../../../components/common/GenericTable";
import { AddressData } from "../../../types/Address";
import { EmergencyContactData } from "../../../types/EmergencyContact";
import { UserData } from "../../../types/User";

export const personTableColumns: ColumnConfig<UserData>[] = [
  { key: "id", label: "Id", searchable: true },
  { key: "firstName", label: "First Name", searchable: true },
  { key: "middleName", label: "Middle Name", searchable: true },
  { key: "lastName", label: "Last Name", searchable: true },
  { key: "email", label: "Email", searchable: true },
  { key: "primaryPhone", label: "Phone", searchable: true },
];

export const addressTableColumns: ColumnConfig<AddressData>[] = [
  { key: "id", label: "Id", searchable: true },
  { key: "country", label: "Country", searchable: true },
  { key: "county", label: "County/Region", searchable: true },
  { key: "city", label: "City", searchable: true },
];

export const contactTableColumns: ColumnConfig<EmergencyContactData>[] = [
  { key: "id", label: "Id", searchable: true },
  { key: "name", label: "Name", searchable: true },
  { key: "primaryPhone", label: "Phone Contact", searchable: true },
  { key: "email", label: "Email", searchable: true },
];
